import addressActions from './actions'

const initState = {
  citiesList: [],
  citiesListStatus: ''
}

export default function motorReducer (state = initState, action) {
  switch (action.type) {
    case addressActions.GET_CITIES_SUCCESS:
    case addressActions.GET_CITIES_FAILURE:
      return {
        ...state,
        citiesList: action.data,
        citiesListStatus: action.message
      }
    case addressActions.RESET_ADDRESS_STORE: {
      const { payload } = action
      const modifyStore = {}
      payload.forEach(stateName => {
        modifyStore[stateName] = ''
      })
      return {
        ...state,
        ...modifyStore
      }
    }
    default:
      return {
        ...state
      }
  }
}
